import { useMutation } from '@apollo/client';
import {
  DTOOLS_AUTHENTICATE,
  GET_DTOOLS_AUTH_DETAILS,
} from 'src/graphql/entities/integrations/dtools/dtools.operations';
import {
  DtoolsAuthDetail,
  DtoolsAuthResponse,
} from 'src/graphql/entities/integrations/dtools/dtools.types';
import { useNotifications } from 'src/utils/hooks';

export type DtoolsAuthenticateQuery = {
  dtoolsAuthenticate: {
    authDetails: DtoolsAuthDetail & { id: number };
  };
};

export type DtoolsAuthenticateQueryVariables = {
  params: {
    apiKey: string;
  };
};

export const useDtoolsAuthenticate = () => {
  const { showErrorAlert } = useNotifications();

  const [connect] = useMutation<DtoolsAuthenticateQuery, DtoolsAuthenticateQueryVariables>(
    DTOOLS_AUTHENTICATE,
    {
      // No optimistic response on purpose: the connected state must only ever come from a key the
      // server has actually validated against D-Tools.
      update: (cache, result) => {
        const authDetails = result.data?.dtoolsAuthenticate.authDetails;
        if (!authDetails) {
          return;
        }
        const partnerId = authDetails?.partnerId;
        if (partnerId === null || partnerId === undefined) return;
        cache.writeQuery<DtoolsAuthResponse>({
          query: GET_DTOOLS_AUTH_DETAILS,
          variables: {
            params: { partnerId },
          },
          data: {
            getDtoolsAuthDetails: {
              authDetails,
            },
          },
        });
      },
      onError: (data) => {
        showErrorAlert(data.message);
      },
    },
  );

  return {
    connect,
  };
};
